/*** IMPORTS FROM imports-loader ***/
var define = false;

import { InvariantError } from "../../utilities/globals/index.js";
export function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw __DEV__ ? new InvariantError("illegal argument: ".concat(key)) : new InvariantError(24);
        }
    }
    return operation;
}
//# sourceMappingURL=validateOperation.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/link/utils/validateOperation.js
// module id = 1549
// module chunks = 0